module.exports = __webpack_public_path__ + "static/media/expand.b1ca4c4e.svg";